import ItSection from '@/views/layouts/SubLayouts/ItSection.vue';
//*********** Hiring */
import DepartmentList from '@/views/ItSection/pages/Department/DepartmentList';
import UserList from '@/views/ItSection/pages/User/UserList';
import ItScheduleList from '@/views/ItSection/pages/ItSchedule/ItScheduleList';
import FacialCheckinDisable from '@/views/ItSection/pages/FacialCheckinDisable/Index';
import Permission from '@/views/ItSection/pages/Permission/Index';
import ItEventEnrollment from '@/views/ItSection/pages/EventEnrollment/Index';
import Feedback from '@/views/ItSection/pages/Feedback/Index';
import QrLogin from '@/views/ItSection/pages/QrLogin/Index';
import ItScheduleExternal from '@/views/HR/WorkPlan/IndexIt';

export default [
    {
      path: 'it-section',
      name: 'ItSection',
      component: ItSection,
      redirect: { name: 'DepartmentList' },
      children:[
        {
            path: 'department-list',
            name: 'DepartmentList',
            component: DepartmentList,
            meta:{
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Tổng quan',
                disabled: true,
                to: {
                    name: "CandidateOverview",
                    }
                },
              ],
            }
        },
        
        {
            path: 'qr-login',
            name: 'QrLogin',
            component: QrLogin
        },
        {
            path: 'feedback',
            name: 'Feedback',
            component: Feedback
        },
        {
            path: 'permission',
            name: 'Permission',
            component: Permission,
        },
        {
            path: 'user-list',
            name: 'UserList',
            component: UserList,
        },
        {
            path: 'it-schedule',
            name: 'ItSchedule',
            component: ItScheduleList,
        },
        {
            path: 'facial-checkin-disable',
            name: 'FacialCheckinDisable',
            component: FacialCheckinDisable,
        },
        {
            path: 'It-Event-Enrollment',
            name: 'ItEventEnrollment',
            component: ItEventEnrollment,
        },
        {
            path: 'it-schedule-external',
            name: 'ItScheduleExternal',
            component: ItScheduleExternal,
        },
      ]
    },
    
  ]
